import React from 'react'
import { getImages } from '../../Common/const'
import TeamMembers from './TeamMembers'
import SeoMeta from '../../Common/SeoMeta'

const OurTeam = () => {
  return (
    <>
      <SeoMeta
        title="European Exotic Center Staff in Tampa, FL and San Clemente, CA"
        description="The European Exotic Center staff prides ourselves on our experienced car sales professionals and trained auto technicians committed to excellence in Tampa, FL and San Clemente, CA."
        keywords=""
        ogTitle="European Exotic Center Staff in Tampa, FL and San Clemente, CA"
        ogDescription="The European Exotic Center staff prides ourselves on our experienced car sales professionals and trained auto technicians committed to excellence in Tampa, FL and San Clemente, CA."
      />
      <section className="common-banner-wrap repair-banner consign-banner">
        <img src={getImages('team-hero-banner.webp')} alt='Our Team' />
        <div className="container">
          <div className='common-banner-pos pt-5 text-center'>
            <h1 className='banner-lg-title text-uppercase wow reveal fadeInUp'>Our Team</h1>
            <div className='md-title font-2em fw-500 text-center mt-3 mb-4 wow reveal fadeInUp avenir-next'>Meet The European Exotic Center Team</div>
          </div>
        </div>
      </section>
      <section className='our-team-content-wrap pb-0'>
        <div className='container'>
          <h2 className='lg-title font-1-9em text-uppercase mb-1 text-orange text-uppercase wow reveal fadeInUp'>AT EUROPEAN EXOTIC CENTER, OUR TEAM IS THE HEART OF EVERYTHING WE DO</h2>
          <div className='common-text wow reveal fadeInUp'>
            <p>As a family-owned dealership established in 2014, we’ve built a staff of passionate automotive professionals who are committed to delivering exceptional service and a high level of expertise. From our knowledgeable sales consultants, to our certified Master Technicians, every member of our team shares a deep appreciation for performance, precision, and customer satisfaction. Please take a moment to meet our team below and, as always, don’t hesitate to call or email us with any questions you may have. </p>
          </div>
        </div>
      </section>
      <section className='our-team-members-wrap'>
        <div className='team-members-block'>
          <div className='container'>
            <TeamMembers/>
          </div>
        </div>
      </section>
    </>
  )
}

export default OurTeam